import { o_util } from "../chunks/common-namespaces-client-CHyZgmlk.mjs";
import { otto } from "../chunks/common-nexus-client-BxVeVD8v.mjs";
import { noop } from "../chunks/common-function-client-BVBvJr6Z.mjs";
const asExport = /*                      */ (namespace, fieldKey, defaultValue) => namespace[fieldKey] ?? defaultValue;
const core = /*           */ asExport(o_util, "core", {});
const isEmptyObject = /*           */ asExport(
  core,
  "isEmptyObject",
  noop
);
const isPlainObject = /*           */ asExport(
  core,
  "isPlainObject",
  noop
);
const withMacrotask = /*           */ asExport(
  core,
  "withMacrotask",
  noop
);
const withRenderSlice = /*           */ asExport(
  core,
  "withRenderSlice",
  noop
);
const coreasync = /*           */ asExport(otto, "grcore", {});
const runWithMicrotask = /*           */ asExport(
  coreasync,
  "runWithMicrotask",
  noop
);
const runWithMacrotask = /*           */ asExport(
  coreasync,
  "runWithMacrotask",
  noop
);
const runWithAnimationFrame = /*           */ asExport(
  coreasync,
  "runWithAnimationFrame",
  noop
);
const runWithRenderSlice = /*           */ asExport(
  coreasync,
  "runWithRenderSlice",
  noop
);
const coerce = /*           */ asExport(core, "coerce", noop);
const deserialize = /*           */ asExport(core, "deserialize", noop);
const serialize = /*           */ asExport(core, "serialize", noop);
const serializeForm = /*           */ asExport(
  core,
  "serializeForm",
  noop
);
export {
  asExport,
  coerce,
  core,
  coreasync,
  deserialize,
  isEmptyObject,
  isPlainObject,
  runWithAnimationFrame,
  runWithMacrotask,
  runWithMicrotask,
  runWithRenderSlice,
  serialize,
  serializeForm,
  withMacrotask,
  withRenderSlice
};
/*                                    */
